(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-result/assets/javascripts/use-selected-result-draw.js') >= 0) return;  svs.modules.push('/components/tipsen/route-result/assets/javascripts/use-selected-result-draw.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useEffect = _React.useEffect,
  useState = _React.useState;
const useQueryParam = svs.components.lbUtils.useQueryParam;
const resolveProductId = svs.utils.products.resolveProductId;
const useSelectedResultDraw = draws => {
  var _draws$, _draws$2;
  const _useState = useState((_draws$ = draws[0]) === null || _draws$ === void 0 ? void 0 : _draws$.drawNumber),
    _useState2 = _slicedToArray(_useState, 2),
    selectedDrawNumber = _useState2[0],
    setSelectedDrawNumber = _useState2[1];
  const _useState3 = useState(resolveProductId((_draws$2 = draws[0]) === null || _draws$2 === void 0 ? void 0 : _draws$2.product)),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedProductId = _useState4[0],
    setSelectedProductId = _useState4[1];
  const drawNumberParam = useQueryParam('draw');
  const productIdParam = useQueryParam('product');
  useEffect(() => {
    if (drawNumberParam) {
      setSelectedDrawNumber(parseInt(drawNumberParam, 10));
    } else {
      setSelectedDrawNumber(draws.length ? draws[0].drawNumber : null);
    }
    if (productIdParam) {
      setSelectedProductId(parseInt(productIdParam, 10));
    } else {
      var _draws$3, _draws$4;
      setSelectedProductId(draws.length && (_draws$3 = draws[0]) !== null && _draws$3 !== void 0 && _draws$3.productId ? (_draws$4 = draws[0]) === null || _draws$4 === void 0 ? void 0 : _draws$4.productId : null);
    }
  }, [drawNumberParam, productIdParam, draws]);
  return [selectedDrawNumber, selectedProductId];
};
setGlobal('svs.components.tipsen.routeResult.useSelectedResultDraw', useSelectedResultDraw);

 })(window);